import OrderForm from 'components/OrderForm/OrderForm';
import SubHeader from 'components/SubHeader/SubHeader';
import { RoutesConfig } from 'navigation/routes';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { OrderProductsSteps, OrderTabsEnum } from 'types/Order.types';

const ProductForm = () => {
  const { orderProductsStep, activeTab } = useSelector(
    (state: RootState) => state.orderInfo
  );

  return (
    <>
      <SubHeader
        isExpanded={
          (location.pathname.includes(RoutesConfig.SupplierNewOrder.fullPath) ||
            location.pathname.includes(RoutesConfig.BuyerNewOrder.fullPath) ||
            location.pathname.includes(
              RoutesConfig.BuyerNewQuotation.fullPath
            )) &&
          orderProductsStep === OrderProductsSteps.Configuration &&
          activeTab === OrderTabsEnum.Products
        }
        inOrderFlow={true}
      />
      <OrderForm />
    </>
  );
};

export default ProductForm;
